module.exports = __webpack_public_path__ + "img/kurand_ec_ksm_bnr_m_02.eed04280.png";